import {t} from "i18next";
import ReactQuill from "react-quill";
import {useState} from "react";
import clsx from "clsx";

export const RichTextEditor = ({
   title,
   setTitle,
   richValue,
   setRichValue,
   error,
   textError,
   onError,
   required = false,
}) => {

    const handleBlur = () => {
        if (required) {
            const hasError = !richValue?.trim();
            onError?.(hasError);
        }
    };

    const showError = error;

    return (
        <>
            <div className={clsx(
                "overflow-hidden rounded-lg border border-gray-300 shadow-sm focus-within:border-indigo-500 focus-within:ring-1 focus-within:ring-indigo-500",
                { "border border-red-500": showError }
            )}>
                <label htmlFor="title" className="sr-only">
                    {t("lead.views.tittle")}
                </label>
                <input
                    id="title"
                    name="title"
                    type="text"
                    placeholder={t("lead.views.tittle")}
                    className={
                        clsx(
                            "block w-full pt-2.5 text-lg font-medium placeholder:text-gray-400 focus:ring-0",
                        )
                    }
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                />
                <label htmlFor="description" className="sr-only">
                    {t("lead.views.description")}
                </label>

                <ReactQuill
                    theme="snow"
                    className={clsx('h-[300px]',
                        {
                            'border-red-500': showError
                        }
                    )}
                    value={richValue}
                    onChange={(val) => {
                        setRichValue(val);
                    }}
                    onBlur={handleBlur}
                />

                {/* Spacer element to match the height of the toolbar */}
            </div>
            {showError && <p className="text-red-600 text-sm">{textError}</p>}
        </>
    );
}